import _                                                           from 'underscore';
import { CustomEventDetails, CustomEventWithDetails, SystemEvent } from '../types/events';

type AnchorElementAttributes = Pick<HTMLAnchorElement, 'href' | 'hreflang' | 'referrerPolicy' | 'rel' | 'target' | 'type'>

export const clickOnLink = function( href = '#', attributes: Partial<Omit<AnchorElementAttributes, 'href'>> = {}, encode = true ){
	
	let link = document.createElement( 'a' );
	
	_.mapObject( attributes, ( value, a ) => link.setAttribute( a, value ) );
	
	link.setAttribute( 'href', encode ? encodeURIComponent( href ) : href );
	
	link.click();
	
	link.remove();
};

export const mailTo = function( email: string ){
	
	if( email ){
		clickOnLink( `mailto:${ email }`, { target: '_blank' }, false );
	}
}

export const saveBlobAsFile = function( fileName: string, fileContents: Blob | BinaryType | string, type: string = 'text/plain' ){
	
	if( typeof ( Blob ) != 'undefined' ){ // using Blob
		
		let textFileAsBlob = ( fileContents instanceof Blob ) ? fileContents : new Blob( [ fileContents ], { type } ),
		    downloadLink   = document.createElement( "a" );
		
		downloadLink.download = fileName;
		
		if( window.webkitURL != null ){
			
			downloadLink.href = window.webkitURL.createObjectURL( textFileAsBlob );
			
		} else {
			
			downloadLink.href          = window.URL.createObjectURL( textFileAsBlob );
			downloadLink.style.display = "none";
			document.body.appendChild( downloadLink );
		}
		
		downloadLink.click();
		
	} else {
		
		let link = document.createElement( 'a' );
		link.setAttribute( 'href', `data:${ type };charset=utf-8,` + encodeURIComponent( fileContents as string ) );
		link.setAttribute( 'download', fileName );
		link.click();
		link.remove();
	}
};

export const saveCSVAsFile = function( fileName: string, fileContents: string ){
	
	saveBlobAsFile( fileName, fileContents, 'text/csv' );
}

export function removeElementsByClass( className: string ){
	let elements = document.getElementsByClassName( className );
	while( elements.length > 0 ){
		elements[ 0 ].parentNode.removeChild( elements[ 0 ] );
	}
}

export function getCSSVar( varName: string, fallback?: any ){
	
	try{
		
		let color = getComputedStyle( document.documentElement ).getPropertyValue( varName );
		
		if( _.isEmpty( color ) ) return fallback;
		
		return color;
		
	} catch( e ) {
		
		// womp
	}
	
	return fallback
}

export function generateCSSPinstripeGradientString( hexColors: string[], angle: number = 135 ){
	
	// See https://stripesgenerator.com/ for info
	
	let colorCount      = hexColors.length,
	    colorStep       = 100 / ( colorCount * 2 ),
	    pinstripeColors = [] as string[];
	
	/* first half */
	hexColors.map( ( color, index ) => {
		
		pinstripeColors.push( `${ color } ${ index * colorStep }%` );
		pinstripeColors.push( `${ color } ${ ( index + 1 ) * colorStep }%` );
		
	} );
	
	/* second half */
	hexColors.map( ( color, index ) => {
		
		pinstripeColors.push( `${ color } ${ ( index + hexColors.length ) * colorStep }%` );
		pinstripeColors.push( `${ color } ${ ( index + hexColors.length + 1 ) * colorStep }%` );
		
	} );
	
	return `linear-gradient(${ angle }deg, ${ pinstripeColors.join( ', ' ) })`;
}

export function generateCustomEventDetails( namespace: string = '', type: string | number = '', details ?: any ): CustomEventDetails{
	return {
		__typename:  `${ namespace }:${ type }`,
		__namespace: namespace,
		__type:      type,
		...details
	}
}

export function getEventDetails( event: CustomEventWithDetails ): object{
	
	return event.details || null;
}

export function applyEventDetails( event: SystemEvent, details: object ): void{
	
	// @ts-ignore
	event.details = details;
}

export function triggerResizeEvent( eventDetails: object = {} ){
	
	if( typeof ( Event ) === 'function' ){
		
		// modern browsers
		let evt = new Event( 'resize' );
		
		applyEventDetails( evt, eventDetails );
		
		window.dispatchEvent( evt );
		
	} else {
		
		// for IE and other old browsers
		// causes deprecation warning on modern browsers
		// @ts-ignore
		let evt = window.createEvent( 'UIEvents' );
		
		evt.initUIEvent( 'resize', true, false, window, 0 );
		
		applyEventDetails( evt, eventDetails );
		
		window.dispatchEvent( evt );
	}
}

export function getWidth(): number{
	return (
		window.innerWidth
		|| document.documentElement.clientWidth
		|| document.body.clientWidth
	);
}

export function getHeight(): number{
	return (
		window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight
	);
}
